import { render, staticRenderFns } from "./IconSvgSnnmiClinicalPractice.vue?vue&type=template&id=0566492f&scoped=true&"
import script from "./IconSvgSnnmiClinicalPractice.vue?vue&type=script&lang=js&"
export * from "./IconSvgSnnmiClinicalPractice.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0566492f",
  null
  
)

export default component.exports